import { apiClient, ApiType } from '@shared/apiClient';

export const fetchInternalLink = async (url: string) => {
  const response = await apiClient.get<string>(ApiType.external, {
    url,
    skipNafHeaders: false, // Keep NAF headers for internal NAF links
  });
  return response.data;
};
